import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { GroupsBackend } from '@libs/src/groups/groups.backend';
import { ToastService } from '@libs/src/toast/toast.service';

import { getServerError } from '@libs/src/error-handler/error-handler.helper';
import { Group } from '@libs/src/models/group.model';

@Injectable()
export class GroupMembersDownloadService {
  private readonly successMessage = $localize`:@@groupMembersDownload.successToast: You will receive an email shortly with members information.`;

  constructor(
    private readonly groupsBackend: GroupsBackend,
    private readonly toastService: ToastService,
  ) {}

  downloadCsv(group: Group) {
    this.groupsBackend
      .getFilesMembersCsv(group)
      .pipe(
        tap(() => this.toastService.showSuccess(this.successMessage)),
        catchError((response: HttpErrorResponse) => {
          this.toastService.showError(getServerError(response));
          return EMPTY;
        }),
      )
      .subscribe();
  }
}
